import { render, staticRenderFns } from "./shuangpu.vue?vue&type=template&id=468a2de4&scoped=true&"
import script from "./shuangpu.vue?vue&type=script&lang=js&"
export * from "./shuangpu.vue?vue&type=script&lang=js&"
import style0 from "./shuangpu.vue?vue&type=style&index=0&id=468a2de4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "468a2de4",
  null
  
)

export default component.exports